import React from 'react';
import { useState, useEffect, useRef } from "react";
import { Input, Select, Button, Divider, notification } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { SearchIconGray, GroupIcon, MilesIcon, CarIcon } from "./icons"; // Import your icons
import axiosInstance from "../../../service/AxiosInstance";
import { DownOutlined } from "@ant-design/icons";
import CustomDropdownRender from "../../../components/SelectDeselect";
const { Option } = Select;
const SearchBar = ({
  isEdit,
  searchBy,
  zipcode,
  setZipcode,
  radius,
  setRadius,
  group,
  setGroup,
  state,
  setState,
  brand,
  setBrand,
  handleSearch,
  showDrawer,
  addToPortfolio,
  radiusPerMile,
  brandsList,
  dealerData,
  dealerLoading,
  showButton,
  alldata,
  hasTimeoutError, // Add hasTimeoutError prop
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const notificationShown = useRef(false);
  const getSearchFeildData = async () => {
    try {
      const { data } = await axiosInstance.get(`/Get_Filterd_Search_Options`);
      const sortedData = {
        ...data,
        GroupTypes: data?.GroupTypes?.sort((a, b) =>
          a.Name.localeCompare(b.Name)
        ),
      };

      setData(sortedData);
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      // setLoading(false);
    }
  };
  const [des, setDes] = useState(true);
  const [api, contextHolder] = notification.useNotification({
    // top: "200px",
    maxCount: 1,
  });
  const openNotification = (message) => {
    api.info({
      message,
      // description: message,
      placement: "top",
      duration: 0,
      style: {
        maxWidth: 1000,
        width: "auto",
        minWidth: 700,
      },
      onClose: () => {
        notificationShown.current = false;
      }
    });
  };
  // THIS useeffect is Showing message in the form of Notification if no data is available for search FieldsX
  useEffect(() => {
    if (searchBy && !dealerLoading && !loading && !hasTimeoutError) { // Don't show no data message if there's a timeout error
      // Check if there's no data in dealerData and also no data in other views
      const hasDataInOtherViews = alldata && (
        (alldata.Rooftopview && alldata.Rooftopview.length > 0) ||
        (alldata.DealerView && alldata.DealerView.length > 0) ||
        (alldata.RooftopView && alldata.RooftopView.length > 0)
      );

      if (dealerData.length === 0 && !hasDataInOtherViews) {
        let message = null;
        if (searchBy === "filter") {
          if (state.length !== 0 || brand.length !== 0) {
            message = (
              <span>
                DMV data for <b>{brand.join(",")}</b> in State
                <b> {state.join(",")} </b> is not available &nbsp; &nbsp;
              </span>
            );
          }
        } else if (searchBy === "radius") {
          if (zipcode && radius) {
            message = (
              <span>
                DMV data is not available for Zipcode <b>{zipcode}</b> in the
                Radius of <b>{radius}</b> Miles &nbsp; &nbsp;
              </span>
            );
          }
        }
        if (message && !notificationShown.current) {
          notificationShown.current = true;
          openNotification(message);
          setDes(false);
        }
      } else {
        setDes(true);
        if (!des) {
          api.destroy();
          notificationShown.current = false;
        }
      }
    }
  }, [dealerData, dealerLoading, alldata, hasTimeoutError]);

  useEffect(() => {
    getSearchFeildData();
  }, []);

  const [dealersZipcode, setDealersZipcode] = useState([]);

  useEffect(() => {
    const dealersZipcode_ = JSON.parse(sessionStorage.getItem("zip_dealers"));
    if (dealersZipcode_) {
      setDealersZipcode(dealersZipcode_);
    } else {
      fetchDealersNZipCode();
    }
  }, []);

  const fetchDealersNZipCode = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(
        `/dealership_zipcode_suggestions`
      );
      setDealersZipcode(data);
      // sessionStorage.setItem("zip_dealers", JSON.stringify(data));
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBrandChange = (value) => {
    setBrand(value);
  };

  // When search is initiated, clear any existing notification
  const handleSearchClick = () => {
    api.destroy();
    notificationShown.current = false;
    handleSearch();
  };

  return (
    <section className={`search_bar ${searchBy}_search_bar`}>
      {contextHolder}
      <div className="search_inputs">
        <div
          className={`input_with_icon pl_zip_dealer ${
            searchBy === "filter" && "group_select"
          }`}
        >
          <span className="icon">
            {searchBy === "radius" ? <SearchIconGray /> : <GroupIcon />}
          </span>
          {searchBy === "radius" ? (
            <Select
              // className="search_box"
              loading={loading}
              placeholder="Select"
              onChange={setZipcode}
              value={zipcode}
              showSearch={true}
            >
              {dealersZipcode.map((brand, index) => (
                <Option key={index} value={brand.Name}>
                  {brand.Name}
                </Option>
              ))}
            </Select>
          ) : (
            <Select
              className="select_box select_rad_brand"
              // placeholder="Group"
              // allowClear={true}
              mode="multiple"
              showSearch
              virtual={true}
              listHeight={256}
              value={group !== "null" && group}
              options={data?.GroupTypes.map((elm) => {
                return {
                  value: elm.Name,
                  label: elm.Name,
                };
              })}
              onChange={(val) =>
                setGroup(val === null || val === undefined ? null : val)
              }
            />
          )}
        </div>
        <div className="input_with_icon radius_select">
          <span className="icon">
            {searchBy === "radius" ? <MilesIcon /> : <CarIcon />}
          </span>
          {searchBy === "radius" ? (
            <Select
              className="select_box"
              placeholder="Select"
              options={radiusPerMile}
              value={radius}
              onChange={(val) => {
                setRadius(val);
              }}
            />
          ) : (
            <Select
              className="select_box select_rad_brand"
              // placeholder="Select"
              showSearch
              virtual={true}
              listHeight={256}
              options={data?.Brands.map((elm) => {
                return {
                  value: elm.Name,
                  label: elm.Name,
                };
              })}
              value={brand}
              onChange={(val) => setBrand(val)}
              mode="multiple"
              // dropdownRender={(menu) => (
              //   <CustomDropdownRender
              //     menu={menu}
              //     onToggleAll={() => {
              //       const allBrandsSelected =
              //         brand.length === data?.Brands.length;
              //       setBrand(
              //         allBrandsSelected
              //           ? []
              //           : data?.Brands.map((brand) => brand.Name)
              //       );
              //     }}
              //   />
              // )}
            />
          )}
        </div>
        <div className="input_with_icon brand_select">
          <span className="icon">
            {searchBy !== "radius" ? <MilesIcon /> : <CarIcon />}
          </span>
          {searchBy === "radius" ? (
            <Select
              className="select_box select_rad_brand"
              // placeholder="Select"
              value={brand}
              style={{
                width: "100%",
              }}
              // virtual={true}
              // defaultValue={brand[0].split(",")}
              // defaultValue={['a10', 'c12']}
              onChange={handleBrandChange}
              mode="multiple"
              dropdownRender={(menu) => (
                <CustomDropdownRender
                  menu={menu}
                  onToggleAll={() => {
                    const allBrandsSelected =
                      brand.length === brandsList.length;
                    setBrand(
                      allBrandsSelected
                        ? []
                        : brandsList.map((brand) => brand.name)
                    );
                  }}
                />
              )}
              // maxCount={MAX_COUNT}
              // suffixIcon={suffix}
            >
              {brandsList.map((brand) => (
                <Option key={brand.id} value={brand.name}>
                  {brand.name}
                </Option>
              ))}
            </Select>
          ) : (
            <Select
              className="select_box state_select select_rad_brand"
              // placeholder="Select"
              showSearch
              options={data?.States.map((elm) => {
                return {
                  value: elm.Name,
                  label: elm.Name,
                };
              })}
              value={state}
              onChange={(val) => setState(val)}
              mode="multiple"
              // dropdownRender={(menu) => (
              //   <CustomDropdownRender
              //   menu={menu}
              //   onToggleAll={() => {
              //     const allStatesSelected = state.length === data?.States.length;
              //     setState(allStatesSelected ? [] : data?.States.map((state) => state.Name));
              //   }}
              // />
              // )}
            />
          )}
        </div>
      </div>
      <div className="search_btn">
        <Button onClick={handleSearchClick} className="as_cta">
          <SearchOutlined />
        </Button>
      </div>

      <div className="save_btn">
        {showButton !== false && (
          <Button onClick={isEdit ? addToPortfolio : showDrawer}>
            {isEdit ? "Add to" : "Save"} Portfolio
          </Button>
        )}
      </div>
    </section>
  );
};

export default SearchBar;
